var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mValue)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.showExtendDetail}},[_vm._v(_vm._s(_vm.mValue.dataValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }